// Floor-map move helpers — pure logic extracted from LoadingBay.tsx's drag
// handlers (PACK floor map). The lane-move guard + the coldroom cell-collision
// error classifier; both keep the operator-facing messaging out of the async
// mutationFns so they're unit-testable.

// A pallet already on a loading mission must not be dragged between lanes — by
// then its lane is part of the loading manifest. There's no DB constraint, so
// this is a client-side guard. Returns the block reason, or null if the move is
// allowed.
export function laneMoveBlockedReason(pallet: { loading_mission_id: string | null }): string | null {
  if (pallet.loading_mission_id) {
    return 'This pallet is already on a loading mission. Detach it from the mission before moving lanes.'
  }
  return null
}

// The coldroom cell-occupancy trigger / unique index (mig 642) raises
// 23P01 / 23505 (and friends) when the target cell already holds a pallet or
// bin. Map those to a clear operator message; return null for any other error
// so the caller rethrows the original.
const CELL_COLLISION = /already holds|cell .*(taken|full)|23P01|23505|duplicate key|violates unique/i

export function coldroomCellCollisionMessage(error: unknown): string | null {
  const msg = error instanceof Error ? error.message : String(error)
  return CELL_COLLISION.test(msg)
    ? 'That cell is already occupied. Pick an empty cell on the floor map.'
    : null
}
